import { render, staticRenderFns } from "./WelcomeScreens.vue?vue&type=template&id=0c7736ae&"
import script from "./WelcomeScreens.vue?vue&type=script&lang=js&"
export * from "./WelcomeScreens.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeScreens.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports